<template>
  <div class="landing-page-global">
    <div class="nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-logo">
          <a href="https://www.simplybrand.com/JP"><img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" /></a>
        </div>
        <div class="nav-bar-mobile">
          <el-button type="button" @click="showmenu"></el-button>
          <ul id="menuitems" v-if="showmobilemenu == true">
            <li><router-link to="/">ホーム</router-link></li>
            <li><a href="https://www.simplybrand.com/JP/about.html">に関して</a></li>
            <li><a href="#requestdemo">デモをリクエストする</a></li>
            <li><router-link to="/CN">中文</router-link></li>
            <li><router-link to="/">EN</router-link></li>
          </ul>
        </div>
        <div class="nav-bar-menu">
          <ul>
            <li class="active-menu"><router-link to="/">ホーム</router-link></li>
            <li><a href="https://www.simplybrand.com/JP/about.html">に関して</a></li>
          </ul>
        </div>
        <div class="nav-bar-signup">
          <router-link class="login-link" to="/Login/Default?lang=jp">ログイン</router-link><a href="#requestdemo">デモをリクエストする</a><router-link class="borderright1px border1" to="/CN">中文</router-link><router-link class="borderright1px" to="/">EN</router-link>
        </div>
      </div>
    </div>

    <div class="section_01">
      <div class="section_01_content">
        <h2>不正な価格設定や偽造品により、あなたのブランドが利益を損なっていませんか？</h2>
        <p>不正なeコマース活動からブランドを守ります。<br>コンプライアンスに反する価格設定と、偽造品を即座に発見します。</p>
        <ul>
          <li class="active-button"><a href="#requestdemo">今すぐ体験</a></li>
          <!-- <li><a href="#requestdemo">Schedule a Demo</a></li> -->
        </ul>
        <div class="section_01_content_img">
          <img src="@/assets/landing-page/img/simplybrand-metrics-jp.png" alt="Metrics" />
        </div>
      </div>
    </div>

    <div class="section_02">
      <div class="section_02_content">
        <h2>アジア太平洋地域全体のブランドを保護する</h2>
        <img src="@/assets/landing-page/img/allclients.png" alt="Protecting brands" />
      </div>
    </div>

    <div class="section_03">
      <div class="section_03_content">
        <div class="section_03_content_right">
          <h2>ブランド保護の核心に効率性を置く</h2>
          <p>あなたの組織のリソースを戦略的な活動に再配置しながら、ブランド保護のプロセスを自動化する</p>
          <ul>
            <li class="icon_01">
              <h3>電子商取引のリスク発見と分析</h3>
              <p>24/7のトラッキングでリセラーの価格遵守を監視します。変化が見つかったときに通知を受け取ります</p>
            </li>
            <li class="icon_02">
              <h3>低価格検出</h3>
              <p>最低宣伝価格（MAP）以下の商品についてアラートを受け取ります。ブランドの評価を下げることを防ぐためにすぐに行動を起こします</p>
            </li>
            <li class="icon_03">
              <h3>不正な販売者</h3>
              <p>21,000以上の市場で不正な販売者を見つけ、高リスクな販売者をフラグします。販売者の知能を使用してアクションプランを決定します</p>
            </li>
            <li class="icon_04">
              <h3>偽造品の特定</h3>
              <p>独自のAI技術を通じて偽造品や知的財産権侵害を発見し、削除の推奨を受け取ります</p>
            </li>
          </ul>
          <a href="#">私たちのすべての機能のリストを見る</a>
        </div>
      </div>
    </div>

    <div class="section_04">
      <div class="section_04_content">
        <div class="section_04_header">
          <h2>simplyBrandを選ぶ理由は何ですか？</h2>
          <p>simplyBrandは、不正な電子商取引活動からあなたのブランドを保護し、非準拠の価格設定を見つけ、即座に偽造品を特定する包括的なソリューションを提供します。</p>
        </div>
        <div class="section_04_body">
          <div class="section_04_body_item section_04_body_item_two">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header is-pc"><img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" /></li>
                <li class="item-header is-mb"><img src="@/assets/landing-page/img/logo-hd-m.png" alt="simplyBrand" /></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="color-red">自動化</li>
                <li class="color-red s_04_b_i">オーバーした料金はありません</li>
                <li class="color-red">低い</li>
              </ul>
            </div>
          </div>
          <div class="section_04_body_item section_04_body_item_one">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header color-red">機能</li>
                <li>AIによるデータ監視</li>
                <li>機械学習を通じたインテリジェンス収集</li>
                <li>非準拠販売者の知能的特定</li>
                <li>リスクレベルの知能的特定</li>
                <li>24/7リアルタイムモニタリング</li>
                <li>地元とグローバルマーケットプレイスのカバレッジ</li>
                <li>デモをリクエストする</li>
                <li>レポート生成</li>
                <li>価格メカニズム</li>
                <li>総費用</li>
              </ul>
            </div>
          </div>
          <div class="section_04_body_item section_04_body_item_two">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header color-grey">その他</li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="color-grey">マニュアル</li>
                <li class="color-grey">オーバー料金</li>
                <li class="color-grey">高い</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section_04_link">
          <a href="#requestdemo">デモをリクエストする</a>
        </div>
        <div class="section_04_brands">
          <div class="section_04_brands_header">
            <h2>成功したブランド保護の努力</h2>
            <p>simplyBrandを使用してブランド保護の努力を強化するグローバルブランドの何百もの加入</p>
          </div>
          <div class="section_04_brands_body">
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img1" src="@/assets/landing-page/img/logo_naturabisse.png" />
                <p>"売り手のチャネル管理に信頼性の高いデータと分析を提供してくれてありがとうございます。それによって、リセラーの管理をより良くし、不正な販売活動と戦うことができました。あなたの支援と支援は、私たちが私たちのブランドイメージを効果的に支えるために役立っています。"</p>
              </div>
            </div>
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img2" src="@/assets/landing-page/img/logo_montes.png" />
                <p>"simplyBrandは私たちに非常に効果的なブランド保護戦略を提供してくれました。高い効果を持つ監視システムと迅速なチームはまた、同じ結果を達成するためのリソースの支出を大幅に削減しました。"</p>
              </div>
            </div>
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img3" src="@/assets/landing-page/img/logo_rehub.png" />
                <p>"simplyBrandに取り組んだ後、高い効果を持ち、スケーラブルで持続可能なシステムを利用して、問題を迅速に発見し、不正な活動を特定し、それにより執行プロセスを加速することができる。"</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section_04_bottom_link">
          <a href="#Request Demo">今すぐ体験</a>
        </div>
      </div>
    </div>

    <div class="section_05">
      <div class="section_05_content">
        <h2>サポートされる電子商取引チャネル</h2>
        <p>定期的に追加される21,000のマーケットプレイスやプラットフォームを監視する</p>
        <img src="@/assets/landing-page/img/platform-logos.png" alt="platform" />
      </div>
    </div>

    <div class="section_06" id="requestdemo">
      <div class="section_06_content">
        <div class="section_06_header">
          <h2 class="s_06_h">あなたのブランドを保護するために始めるのは決して早すぎることはありません</h2>
          <p>デモを見るために私たちの技術が実際に動作するように登録してください</p>
        </div>
        <div class="section_06_form">

          <el-form ref="form" :rules="rules" :model="form" size="small">
            <el-form-item prop="name" class="section_06_form_item">
              <el-input v-model="form.name" placeholder="名前*" class="input_01"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_item">
              <el-input v-model="form.email" type="email" placeholder="Eメール*" class="input_02"></el-input>
            </el-form-item>
            <el-form-item prop="tel" class="section_06_form_item">
              <el-input v-model="form.tel" type="tel" placeholder="携帯電話番号." class="input_03"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_item">
              <el-input v-model="form.company" placeholder="会社名*" class="input_04"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_button">
              <el-button size="mini" type="primary" @click="sendEmail('form')" :loading="loading">デモのスケジュール</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="site-footer">
      <div class="site-footer-content">
        <div class="site-footer-item site-footer-item-logo">
          <div class="site-footer-item-header">
            <img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" />
          </div>
          <div class="site-footer-body">
            <p>ブランド保護をより透明で効率的なプロセスにすることを私たちの使命にする</p>
          </div>
        </div>
        <div class="site-footer-item site-footer-item-ul">
          <div class="site-footer-item-header">
            <!-- <h3>Product Features</h3> -->
          </div>
          <div class="site-footer-body">
            <!-- <ul>
              <li><a href="#">Price Monitor</a></li>
              <li><a href="#">Unauthorized Seller</a></li>
              <li><a href="#">Digital Defense</a></li>
              <li><a href="#">Infringements</a></li>
            </ul> -->
          </div>
        </div>
        <div class="site-footer-item site-footer-item-contact">
          <div class="site-footer-item-header">
            <h3>お問い合わせ</h3>
          </div>
          <div class="site-footer-body">
            <p>contact@simplybrand.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      form: {
        name: '',
        from: '',
        tel: '',
        brand: '',
        company: '',
        email: '',
        href: ''
      },
      rules: {
        name: [
          { required: true, message: 'Name', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: 'Mobile No.', trigger: 'blur' },
        ],
      },
      showmobilemenu: false
    }
  },
  mounted(){

    /**
     * 添加客服图标
     */
    // let kchatid = '1040402'
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = 'https://assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay()
    // script.id = 'kf5-provide-supportBox'
    // script.charset = "utf-8"
    // script.setAttribute('kchat-id', kchatid)
    // script.setAttribute('kf5-domain', 'simplybrand.kf5.com')
    // document.getElementsByTagName('head')[0].appendChild(script)

  },
  methods: {

    sendEmail: function(formName){
      let that = this
      that.form.from = that.$route.query.ref == undefined ? '非推广来源' : that.$route.query.ref
      that.form.href = window.location.href
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          // let url = '//similarpic.simplybrand.com/api/userInfo/sendMail'
          let url ='/sendMail'
          $.ajax(url, {
            type: "POST",
            data: that.form,
            success: function(data) {
              console.log(data)
              that.showform = false
              that.loading = false
              that.form = {}
              that.$message({
                showClose: true,
                message: 'Success',
                type: 'success'
              })
            },
            error: function(response) {
              console.log(response)
              that.$message.error('Err')
            }
          })
        } else {
          this.$message.error('Err')
          return false
        }
      })
    },

    showmenu: function(){
      let that = this
      let _current = that.showmobilemenu
      console.log(_current)
      if(_current == false){
        that.showmobilemenu = true
      }else{
        that.showmobilemenu = false
      }
    },
  }
}
</script>
